import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import colors from '../../foundations/colors.module.scss';
const themeMap = {
    dark: colors.dark900,
    light: colors.dark50
};
export const AnchorLogo = (props)=>/*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 133.501 38.911"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "anchor-logo-linear-gradient-1",
                        x1: "-.486",
                        x2: "1.553",
                        y1: ".693",
                        y2: ".206",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".18",
                                stopColor: "#4a0d73"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".277",
                                stopColor: "#7c2091"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".374",
                                stopColor: "#a731ab"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".461",
                                stopColor: "#c53dbd"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".535",
                                stopColor: "#d845c8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".586",
                                stopColor: "#df48cd"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "anchor-logo-linear-gradient-2",
                        x1: "1.174",
                        x2: "-.716",
                        y1: ".029",
                        y2: "1.562",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".045",
                                stopColor: "#001480",
                                stopOpacity: ".898"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".079",
                                stopColor: "#063194",
                                stopOpacity: ".918"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".162",
                                stopColor: "#1673c1",
                                stopOpacity: ".953"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".233",
                                stopColor: "#21a3e2",
                                stopOpacity: ".976"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".286",
                                stopColor: "#28c1f7",
                                stopOpacity: ".992"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".316",
                                stopColor: "#2bcdff"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".429",
                                stopColor: "#3edbdb"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".562",
                                stopColor: "#52eab7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".634",
                                stopColor: "#5af0aa"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "anchor-logo-linear-gradient-3",
                        x1: "-.679",
                        x2: "1.269",
                        y1: "1.604",
                        y2: "-.273",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".423",
                                stopColor: "#643cff"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".609",
                                stopColor: "#7268ff"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".774",
                                stopColor: "#7d89ff"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: ".865",
                                stopColor: "#8296ff"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("g", {
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M-1065.022 4409.537c5.2.912 11.674-10 11.674-10l-12.371.81c-1.592 4.643-1.96 8.105.697 9.19z",
                        style: {
                            fill: 'url(#anchor-logo-linear-gradient-1)'
                        },
                        transform: "translate(1100.559 -4370.68)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M-1120.156 4326.8c-1.154-1.7-.743-1.873-2.88-2.2-.679-.1-1.111-2.546-7.435.742-8.449 4.393-21.934 19.426-25.4 24.043l16.484-1.079c3.74-4.41 11.225-12.673 15.613-14.879 2.912-2.022 5.131-4.391 3.618-6.627z",
                        style: {
                            fill: 'url(#anchor-logo-linear-gradient-2)'
                        },
                        transform: "translate(1155.867 -4323.461)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M-1076.707 4341.959c.248-.556.472-.977.587-1.252 2.279-5.495 4.894-9.258 1.453-13.372-2.346-2.8-8.674-5.585-14.062-3.352 2.28-.482 4-.325 5.115 1.319 1.95 2.89-2.112 9.011-3.612 12.206a88.24 88.24 0 0 0-4.471 10.292c-.832 2.585-1.521 5.892.314 8.226 1.589 2.02 6.11 4.445 7.367 4.987a10.845 10.845 0 0 0 3.408 1.054c-4.82-1.935.608-12.76 3.901-20.108z",
                        style: {
                            fill: 'url(#anchor-logo-linear-gradient-3)'
                        },
                        transform: "translate(1116.472 -4323.17)"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("g", {
                transform: "translate(50.709 6.585)",
                style: {
                    fill: themeMap[props.theme || 'dark']
                },
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.781 7.644a6.126 6.126 0 0 0-2.043-1.76 6.3 6.3 0 0 0-3.01-.73 6.625 6.625 0 0 0-3.441.922 6.488 6.488 0 0 0-2.418 2.54A7.476 7.476 0 0 0 0 12.2a7.474 7.474 0 0 0 .869 3.582 6.5 6.5 0 0 0 2.418 2.541 6.633 6.633 0 0 0 3.441.921 6.3 6.3 0 0 0 3.01-.729 6.126 6.126 0 0 0 2.043-1.76v2.172h2.434V5.472h-2.434zm-1.323 1.21a4.6 4.6 0 0 1 1.323 3.346 4.6 4.6 0 0 1-1.323 3.344 4.479 4.479 0 0 1-3.312 1.342 4.512 4.512 0 0 1-3.331-1.342A4.578 4.578 0 0 1 2.486 12.2a4.58 4.58 0 0 1 1.329-3.346 4.515 4.515 0 0 1 3.331-1.341 4.482 4.482 0 0 1 3.312 1.341"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M23.8 5.154a5.562 5.562 0 0 0-4.673 2.129V5.471h-2.434v13.454h2.435v-7.539A3.793 3.793 0 0 1 20.2 8.575a3.932 3.932 0 0 1 2.875-1.063 3.689 3.689 0 0 1 2.747 1.044 3.806 3.806 0 0 1 1.025 2.779v7.59h2.435v-8.288a5.389 5.389 0 0 0-1.509-3.981 5.406 5.406 0 0 0-3.974-1.5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M37.892 7.513a4.688 4.688 0 0 1 2.362.614A4.413 4.413 0 0 1 41.918 9.8l.051.09 2.115-1.272-.05-.086A6.664 6.664 0 0 0 41.5 6.063a7.275 7.275 0 0 0-3.6-.908 7.4 7.4 0 0 0-3.654.92 6.718 6.718 0 0 0-2.583 2.539 7.057 7.057 0 0 0-.934 3.585 7.057 7.057 0 0 0 .934 3.585 6.728 6.728 0 0 0 2.583 2.54 7.41 7.41 0 0 0 3.654.919 7.288 7.288 0 0 0 3.6-.908 6.62 6.62 0 0 0 2.544-2.48l.05-.085-2.125-1.27-.051.089a4.45 4.45 0 0 1-1.664 1.677 4.638 4.638 0 0 1-2.362.621 4.517 4.517 0 0 1-3.331-1.341 4.584 4.584 0 0 1-1.33-3.345 4.587 4.587 0 0 1 1.329-3.347 4.521 4.521 0 0 1 3.332-1.341"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M52.542 5.154a5.5 5.5 0 0 0-4.674 2.2V0h-2.435v18.925h2.435v-7.539a3.793 3.793 0 0 1 1.074-2.811 3.932 3.932 0 0 1 2.875-1.063 3.686 3.686 0 0 1 2.747 1.044 3.8 3.8 0 0 1 1.025 2.779v7.59h2.435v-8.288a5.392 5.392 0 0 0-1.508-3.981 5.411 5.411 0 0 0-3.974-1.5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M66.632 5.154a7.4 7.4 0 0 0-3.654.92A6.729 6.729 0 0 0 60.4 8.613a7.063 7.063 0 0 0-.935 3.585 7.058 7.058 0 0 0 .935 3.585 6.732 6.732 0 0 0 2.582 2.54 7.413 7.413 0 0 0 3.654.92 7 7 0 0 0 5.092-2.022 6.8 6.8 0 0 0 2.05-5.021 6.794 6.794 0 0 0-2.054-5.022 7 7 0 0 0-5.092-2.022m3.313 10.389a4.785 4.785 0 0 1-6.644 0 4.583 4.583 0 0 1-1.329-3.345A4.581 4.581 0 0 1 63.3 8.854a4.783 4.783 0 0 1 6.644 0 4.59 4.59 0 0 1 1.324 3.346 4.591 4.591 0 0 1-1.323 3.345"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M82.248 5.256a5.1 5.1 0 0 0-4.419 2.268V5.472h-2.435v13.454h2.435V12.2a4.417 4.417 0 0 1 1.183-3.236 4.36 4.36 0 0 1 3.236-1.2h.544V5.256z"
                    })
                ]
            })
        ]
    }));
